import { useSector } from "../lib/sector";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
} from "./ui/select";
import { Sliders } from "lucide-react";

export default function SectorPicker({ compact = false }) {
    const { sectorId, sectors, setSectorId, current, disclaimer } = useSector();

    return (
        <div
            className="flex items-center gap-2"
            data-testid="sector-picker"
        >
            <Sliders size={14} strokeWidth={1.5} className="text-slate-500" />
            {!compact && (
                <span className="font-mono text-[11px] tracking-[0.22em] uppercase text-slate-500 hidden md:inline">
                    Sector preset
                </span>
            )}
            <Select value={sectorId} onValueChange={setSectorId}>
                <SelectTrigger
                    className="h-9 rounded-sm border-slate-300 bg-white text-xs font-medium tracking-tight w-[180px]"
                    data-testid="sector-picker-trigger"
                    title={current?.note || disclaimer}
                >
                    <span className="truncate text-left">
                        {current?.label || "Select sector"}
                    </span>
                </SelectTrigger>
                <SelectContent className="rounded-sm">
                    {sectors.map((s) => (
                        <SelectItem
                            key={s.id}
                            value={s.id}
                            data-testid={`sector-option-${s.id}`}
                        >
                            <div className="flex flex-col py-0.5">
                                <span className="text-sm">{s.label}</span>
                                <span className="text-[10px] text-slate-500 font-mono mt-0.5">
                                    {s.note}
                                </span>
                            </div>
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
}

export function SectorDisclaimer() {
    const { disclaimer } = useSector();
    if (!disclaimer) return null;
    return (
        <p
            className="text-xs text-slate-500 italic"
            data-testid="sector-disclaimer"
        >
            {disclaimer}
        </p>
    );
}

export function ActiveSectorPill() {
    const { current } = useSector();
    if (!current) return null;
    return (
        <span
            className="inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.18em] uppercase text-slate-700 border border-slate-300 px-2.5 py-1 rounded-sm bg-white"
            data-testid="active-sector-pill"
        >
            <span className="dot" style={{ background: "#0f172a" }} />
            Sector · {current.label}
        </span>
    );
}
